export var isNodeOrNull = function (value) {
  return null === value || value instanceof Node;
};